// Lib
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// Components
import Header from './Header';
import Footer from './Footer';

// Constants
import USER_TYPE from '../../constants/user';

// Hooks
import useUser from '../../hooks/useUser';

// Styles
import { useStyles } from './LayoutStyles';

const Layout = ({
  children,
  className,
  renderComponent,
  hideHeaderLinks,
  searchResults = [],
  onChangeSearch,
  onlyContent = false,
  title = '',
}) => {
  const { userType, isLoggedIn } = useUser();
  const { pathname } = useLocation();
  const { classes, cx } = useStyles();
  const isKiteUser = userType === USER_TYPE.kite;

  const isAuthPage = useMemo(
    () => pathname === '/auth' || pathname === '/auth/',
    [pathname],
  );

  return (
    <>
      <Header
        title={title}
        onlyContent={onlyContent}
        isKiteUser={isKiteUser}
        isAuthPage={isAuthPage}
        isLoggedIn={isLoggedIn}
        onlyLogoLink={hideHeaderLinks}
        searchResults={searchResults}
        onChangeSearch={onChangeSearch}
      />
      {renderComponent && renderComponent()}
      <div className={cx(classes.root, className?.layout)}>{children}</div>
      {!isAuthPage && !onlyContent && (
        <Footer isKiteUser={isKiteUser} className={className?.footer} />
      )}
    </>
  );
};

export default Layout;
